module.exports = __webpack_public_path__ + "img/replay-button.3345445e.png";